export default "__VITE_ASSET__DVucLEiP__"